import { useEffect, useRef, useState } from "react";

const listeners = new Set();
let socket = null;
let retry = 0;
let timer = null;

function connect() {
  const token = localStorage.getItem("tk_token");
  if (!token || socket) return;
  const url = `${process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws")}/api/ws?token=${encodeURIComponent(token)}`;
  socket = new WebSocket(url);
  socket.onopen = () => { retry = 0; };
  socket.onmessage = (e) => {
    try {
      const msg = JSON.parse(e.data);
      listeners.forEach((fn) => fn(msg));
    } catch {}
  };
  socket.onclose = () => {
    socket = null;
    if (listeners.size === 0) return;
    clearTimeout(timer);
    timer = setTimeout(connect, Math.min(30000, 1000 * 2 ** retry++));
  };
}

function subscribe(fn) {
  listeners.add(fn);
  connect();
  return () => {
    listeners.delete(fn);
    if (listeners.size === 0 && socket) socket.close();
  };
}

export function useRealtimeTick(filter) {
  const [tick, setTick] = useState(0);
  const debounce = useRef();
  const filterRef = useRef(filter);
  filterRef.current = filter;
  useEffect(() => subscribe((msg) => {
    if (filterRef.current && !filterRef.current(msg)) return;
    clearTimeout(debounce.current);
    debounce.current = setTimeout(() => setTick((t) => t + 1), 350);
  }), []);
  return tick;
}
